<template>
  <v-card
    rounded
    elevation="20"
    :to="{ name: 'player', params: { id: player.id }}"
  >
    <v-card-title>
      <div
        v-if="player.description"
        class="subtitle-1 primary--text"
      >
        {{ player.description }}
      </div>
      <div
        v-else
        class="subtitle-1 grey--text text--lighten-1"
      >
        Unknown
      </div>
    </v-card-title>
    <v-card-text>
      <v-row
        no-gutters
        class="mb-2"
      >
        <v-col>
          <span
            v-if="player.radio"
            class="secondary--text"
          >
            {{ player.radio.title }}
          </span>
          <span
            v-else
            class="grey--text"
          >
            no
          </span>
          radio
        </v-col>
        <v-col
          cols="auto"
          class="pl-2"
        >
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-chip
                small
                :color="player.player_status === 'online' ? 'green darken-1' : offlineChipColor(player.player_last_online_at)"
                text-color="white"
                dark
                class="ma-0"
                v-on="on"
              >
                {{ player.player_status === 'online' ? 'Online' : 'Offline' }}
              </v-chip>
            </template>
            <span v-if="player.player_status === 'online'">
              Status updated <strong>{{ $dayjs(player.player_status_at).from(now) }}</strong>, on {{ $dayjs(player.player_status_at).format('DD.MM.YYYY. HH:mm:ss') }}
            </span>
            <span v-else-if="player.player_status === 'offline'">
              Last online <strong>{{ $dayjs(player.player_last_online_at).from(now) }}</strong>, on {{ $dayjs(player.player_last_online_at).format('DD.MM.YYYY. HH:mm:ss') }}
            </span>
          </v-tooltip>
        </v-col>
      </v-row>
      <div v-if="player.player_status === PLAYER_STATUS_OFFLINE">
        Last online <strong>{{ $dayjs(player.player_last_online_at).from(now) }}</strong>, on {{ $dayjs(player.player_last_online_at).format('DD.MM.YYYY. HH:mm:ss') }}
      </div>
    </v-card-text>
    <div v-if="player.player_status === PLAYER_STATUS_ONLINE && player.last_playback_log">
      <v-divider />
      <v-card-text :style="{ color:eventSpecs[player.last_playback_log.event].color }">
        <v-row
          no-gutters
          align="center"
        >
          <v-col>
            <v-avatar size="30px">
              <v-icon
                x-small
                :color="eventSpecs[player.last_playback_log.event].color"
              >
                {{ eventSpecs[player.last_playback_log.event].icon }}
              </v-icon>
            </v-avatar>
            <span v-if="player.last_playback_log.library_file">
              <span
                v-if="player.last_playback_log.library_file.artist || player.last_playback_log.library_file.title"
              >
                {{ player.last_playback_log.library_file.artist + ' - ' }}{{ player.last_playback_log.library_file.title }}
              </span>
              <span
                v-if="!player.last_playback_log.library_file.artist || !player.last_playback_log.library_file.title"
              >
                {{ player.last_playback_log.library_file.original_file }}
              </span>
            </span>
            <span
              v-else
              class="grey--text"
            >
              -
            </span>
          </v-col>
          <v-col cols="auto">
            <img
              src="@/assets/equalizer.svg"
              :style="{ color: eventSpecs[player.last_playback_log.event].color }"
            >
          </v-col>
        </v-row>
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
import PlayerLogModel from '@/models/PlayerLogModel'
import PlayerModel from '@/models/PlayerModel'

export default {
  name: 'MobilePlayerCard',
  props: {
    player: {
      type: Object,
      required: true
    }
  },
  methods: {
    offlineChipColor(lastOnlineAt) {
      if (!lastOnlineAt) return 'red darken-4'
      const diffDays = this.$dayjs().diff(this.$dayjs(lastOnlineAt), 'day')
      if (diffDays < 1) return 'yellow darken-1'
      if (diffDays < 30) return 'orange darken-1'
      if (diffDays < 90) return 'red lighten-1'
      return 'red darken-4'
    }
  },
  created() {
    this.eventSpecs = PlayerLogModel.eventSpecs

    this.PLAYER_STATUS_ONLINE = PlayerModel.STATUS_ONLINE
    this.PLAYER_STATUS_OFFLINE = PlayerModel.STATUS_OFFLINE
  }
}
</script>

<style scoped>

</style>
